import { Injectable } from '@angular/core';
import { GlameraIconDefinition } from '@glamera/animated-icons/core';

@Injectable({ providedIn: 'root' })
export class GlameraIconRegistry {
  private readonly icons = new Map<string, GlameraIconDefinition>();

  register(icons: GlameraIconDefinition | readonly GlameraIconDefinition[]): void {
    const list = Array.isArray(icons) ? icons : [icons];
    for (const icon of list) {
      this.icons.set(icon.name, icon);
    }
  }

  get(name: string): GlameraIconDefinition | undefined {
    return this.icons.get(name);
  }

  has(name: string): boolean {
    return this.icons.has(name);
  }

  names(): string[] {
    return Array.from(this.icons.keys());
  }
}
